<template>
<div ref="caroussel-image-container" class="caroussel-image-container">
    <img  v-if="lazySrc" @load="loadImage" @error="errorImage" style="display:none" :src="lazySrc">
    
    <div @click="startPlay" class="image-holder" :style="computeImageStyle" :class="{'animate':animate}">
      <div ref="image-originer" class="image-originer">
      <div ref="image-scaler" class="image-scaler" :style="computeZoom">
        <div class="bg-image-small" :style="computeLqStyle"></div>
        <div ref="big-image" class="bg-image-big" :style="computeHqStyle"></div>
        <ui-icon v-if="media.type=='youtube'" class="play-button" icon="film"></ui-icon>
        <ui-icon v-if="media.type=='mp3'" class="play-button" icon="music"></ui-icon>
        <ui-icon v-if="media.type=='pdf'" class="play-button" icon="file-pdf"></ui-icon>
        
      </div>
      
      <!--
        <ui-chip class="filename" color="#FFFFFF" backgroundColor="rgba(0,0,0,.25)" icon=""> {{media.filename}}</ui-chip>
      -->
      </div>
      <!--
      <audio ref="audio-player" class="audio-player" controls>
          <source :src="media.url" type="audio/mpeg">
          :( Audio not supported..
        </audio>
      -->
    </div>
    
   
</div>
</template>

<script>
import { eventBus } from '../../services/EventBus.js';
import UiIcon from '../../components/UiIcon.vue';
import { youtubePlayer } from '../../services/youtubePlayer/YoutubePlayer.js';
import { audioPlayer } from '../../services/audioPlayer/AudioPlayer.js';


export default {
  name: 'caroussel-image',
  props:{
    media:{youtubeId:undefined, url:"",thumbnail:""},
    position:{default:0},
  },
  data(){
    return {
      backgroundHq:"",
      backgroundLq:"",
      element:undefined,
      rotation:0,
      opacity:1,
      animate:false,
      lazySrc:false,
      zoomScale:1.0,
      offsetX:0,
      offsetY:0,
      baseX:0,
      baseY:0,
      zooming:false,
      zoomOrigin:{x:200,y:200},
      updateKey:0,
    }
  },
  components: {
    UiIcon,
  },
  computed:{
    computeImageStyle:function(){
      //var s=(this.zoomScale*100)+"%";
      //return {width:s, height:s}
      
      //var invScale=1-(2-this.zoomScale);
      //var offset=(50*invScale);

      //var offsetX=0;//offset;
      //var offsetY=0;//offset;

      //return {transform:"translate("+this.offsetX+"px,"+this.offsetY+"px) scale("+this.zoomScale+")"}
     //return {transform:"translate("+this.offsetX+"px,"+this.offsetY+"px)"}
     //var midx=0;//200;
     return {transform:"translate("+this.offsetX+"px,"+this.offsetY+"px)"}
    
    },
    computeZoom:function(){
      //var invZoomscale=(2-this.zoomScale)+1;
      //console.log(this.zoomScale)
      //var bcr=this.element ? this.element.getBoundingClientRect():{width:1,heigth:1}
      //var bcr_scaler=this.imgScaler.getBoundingClientRect();

      //var midx=-9000;

      //var tox=-this.offsetX;//-(bcr.width/2)/this.zoomScale;
      //var toy=-this.offsetY;//-(bcr.height/2)/this.zoomScale;
 //console.log(tox)
      //console.log(tx,ty)
      //return {transformOrigin:tx+"px "+ty+"px",transform:"scale("+this.zoomScale+")"}
      //var tox=0-(this.offsetX/this.zoomScale);//-(bcr.width/2)/this.zoomScale;
      //var toy=0-this.offsetY;//-(bcr.height/2)/this.zoomScale;
      
      return {transform:"scale("+this.zoomScale+")"}
      
    },
    computeOrigin(){
       //var tox=0;//-this.offsetX;//-(bcr.width/2)/this.zoomScale;
      //var toy=0;//-this.offsetY;//-(bcr.height/2)/this.zoomScale;
      //return {transformOrigin:tox+"px "+toy+"px"}
      return {}
    },
    computeLqStyle:function(){

       return {backgroundImage:"url("+this.media.thumb+")"}
    },
    computeHqStyle:function(){
      
      //
      //var offsetY=(this.big_element.clientHeight-this.holder_element.clientHeight)/2;
      
      
      //var invScale=(2-this.zoomScale);

      //var offset=(50*invScale);

      //var offsetX=-offset;
      //var offsetY=-offset;
      
      //var s=(this.zoomScale*100)+"%";
     
      
      //return {backgroundImage:"url("+this.backgroundHq+")", transform:"translate("+offset+"%,0px) scale("+this.zoomScale+")"}
      //return {backgroundImage:"url("+this.backgroundHq+")", transform:"scale("+this.zoomScale+")"}
      return {backgroundImage:"url("+this.backgroundHq+")"}
    },
    
    
  },
  methods:{
    startPlay(){
      // youtube playing in native player not working for browser..

      switch(this.media.type){
        case "youtube":
           youtubePlayer.load(this.media.youtubeId)
        break;
        case "mp3":
           audioPlayer.load(this.media.url)
        break;
      }
      


    },
    lazyLoadPosition(obj){
      
      if(obj.position==this.position && !this.lazySrc){
       this.lazySrc=this.media.url;
      
      }

      if(obj.position==this.position){
        this.$nextTick(()=>{
          
        })
        setTimeout(()=>{
          this.audioPlayer ? this.audioPlayer.click(): true;
        },1000)
      }


      // reset scale and drag position of non visible items,
      // this i called when swiping the caroussel to go to the next image
      if(obj.position!=this.position){
        this.zoomScale=1.0;
        this.offsetX=0;
        this.offsetY=0
        this.zooming=false;
        this.audioPlayer ? this.audioPlayer.pause(): true;
        
         
      }

    },
    loadImage(e){
     
      // high quality image is loaded
      this.backgroundHq=e.target.src;
      
    },
    errorImage(){
      this.backGroundUrl=require('../../assets/thumb_404.png');
    },
    calulateImageRotation(payload){

      var bound=this.element.getBoundingClientRect();
      var percent;
      
      switch(payload.type){
        case "start":
          this.animate=false;
        break;
        case "end":
          this.animate=true;
         
          if(this.position<payload.position){
            percent=-1;
          }
          if(this.position>payload.position){
            percent=1;
          }
          if(this.position==payload.position){
            percent=0;
          }
        break;
        case "move":
          percent=bound.x/window.innerWidth;
        break;
      }
      this.rotation=90*percent;
      this.opacity=1-percent;

    },
    calculateZoom(payload){
      this.zooming=true;
      var position=payload.position;
      var scale=payload.scale;

      if(this.position==position){ // index position in caroussel
        this.zoomScale=scale;
        if(this.zoomScale<=1.0){
          this.zoomScale=1.0;
        }
      }

      this.clipDrag();

      //this.offsetX=0;
      //this.offsetY=0;

      // center scroll when zooming
      /*
      var sl = this.holder.offsetLeft + (this.holder.clientWidth / 2);
      var st = this.holder.offsetTop + (this.holder.clientHeight / 2);
      this.holder.scrollLeft=sl;
      this.holder.scrollTop=st;
      */
    },
    dragStart(e){
      //if(e.touches.length>=2){
        // calculate zoom center (transform origin)
        //var pa={x:e.targetTouches[0].pageX,y:e.targetTouches[0].pageY}
        //var pb={x:e.targetTouches[1].pageX,y:e.targetTouches[1].pageY}
        //this.zoomOrigin={x:pa.x+((pb.x-pa.x)/2),y:pa.y+((pb.y-pa.y)/2)}
     // }

      if(this.zooming){
        return;
      }

      if(this.zoomScale==1.0){
        return;
      }

      this.startX=e.touches[0].clientX;
      this.startY=e.touches[0].clientY;
    
    },
    dragMove(e){
       if(this.zooming){
        return;
      }

      if(e.touches.length>=2){
       
        return;
      }

      

      var moveX=e.touches[0].clientX-this.startX;
      var moveY=e.touches[0].clientY-this.startY;


      this.offsetX=this.baseX+moveX;
      this.offsetY=this.baseY+moveY;

      // clip dragging picture
      this.clipDrag();



      e.preventDefault();
      //e.stopImmediatePropagation();
      

    },
    // keep image in boundarties
    clipDrag(){
      
      var bcr=this.element.getBoundingClientRect();
      var bcr_scaler=this.imgScaler.getBoundingClientRect();

      var xmin=(bcr_scaler.width-bcr.width)/2;
      var ymin=(bcr_scaler.height-bcr.height)/2;

      if(this.offsetX>xmin ){
        this.offsetX=xmin;
      }
      if(this.offsetY>ymin){
        this.offsetY=ymin;
      }
      
      
      var xmax=((bcr_scaler.width-bcr.width)/2)
      var ymax=((bcr_scaler.height-bcr.height)/2)
      if(this.offsetX<-xmax){
        this.offsetX=-xmax;
      }
      if(this.offsetY<-ymax){
        this.offsetY=-ymax;
      }

      if(this.zoomScale<=1.0){
        this.offsetX=0;
        this.offsetY=0;
       
      }


      

    },
    dragEnd(e){
      if(e.targetTouches.length==0){
        this.zooming=false;
      }
       
      this.baseX=this.offsetX;
      this.baseY=this.offsetY;

      this.clipDrag();
    },
  },
  beforeDestroy(){
     eventBus.$off("CAROUSSEL_IMG_ROTATION",this.calulateImageRotation);
     eventBus.$on("CAROUSSEL_IMG_ZOOM",this.calculateZoom);
     eventBus.$off("LAZY_LOAD_POSITION",this.lazyLoadPosition);

    // for pinch zooming the image
    this.element.removeEventListener('touchstart',this.dragStart);
    this.element.removeEventListener('touchend',this.dragEnd);
    this.element.removeEventListener('touchmove',this.dragMove);
  },
  created(){
    
  },
  mounted:function(){
    this.element=this.$refs['caroussel-image-container'];
    //this.bigImage=this.$refs['big-image'];
    
    

    this.imgScaler=this.$refs['image-scaler'];
    this.audioPlayer=this.$refs['audio-player'];

    eventBus.$on("CAROUSSEL_IMG_ZOOM",this.calculateZoom);
    eventBus.$on("CAROUSSEL_IMG_ROTATION",this.calulateImageRotation);
    eventBus.$on("LAZY_LOAD_POSITION",this.lazyLoadPosition);
    

    this.element.addEventListener('touchstart',this.dragStart);
    this.element.addEventListener('touchend',this.dragEnd);
    this.element.addEventListener('touchmove',this.dragMove,{passive:false});



    this.lazyLoadPosition({position:0});
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.caroussel-image-container{
  width:100%;
  height:100%;
  display:inline-block;
  perspective: 60em;
  perspective-origin: center center;
  /*overflow:scroll;*/
  /*border:1px solid red;*/
}
.caroussel-image-container::-webkit-scrollbar {
  display: none;
}

.image-holder{
  position:relative;
  width:100%;
  height:100%;
}
.filename{
  position:absolute;
  top:0;
  left:0px;
  font-size:.7em;
  padding:4px;
}
.image-scaler{
  transform: translateZ(0);
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  display:inline-flex;
  justify-content: center;
  align-items: center;
  /*border:2px solid green;*/
}
.image-originer{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  /*border:2px solid yellow;*/
}

.bg-image-small, .bg-image-big{
  position:absolute;
  top:0;
  left:0;
  background-position:center;
  background-size:contain;
  background-repeat:no-repeat;
  width:100%;
  height:100%;
  justify-content: center;
  align-items: center;
}
.play-button{
  position:absolute;
  font-size:2em;
}
.animate{
  transition:transform .25s;
}

.audio-player{
  display: block;
  width: 100%!important;
}

</style>
